import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import TeacherDashboard from "./pages/TeacherDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdmissionEnquiryForm from "./pages/AdmissionEnquiryForm";
import ViewEnquiryList from "./pages/ViewEnquiryList";
import ViewEnquiryTable from "./pages/ViewEnquiryTable";
import AddNewUser from "./pages/AddNewUser";
import ManagerUser from "./pages/ManagerUser";
import ProtectedRoute from "./components/ProtectedRoute";
import ResetPasswordPage from "./pages/ResetPasswordPage";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Open Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/enquiry/form" element={<AdmissionEnquiryForm />} />

        {/* Staff Routes */}
        <Route
          path="/teacher/home"
          element={
            <ProtectedRoute requiredRoles={["staff"]} showHeader={true}>
              <TeacherDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/enquiry/view"
          element={
            <ProtectedRoute
              requiredRoles={["admin", "manager", "staff"]}
              showHeader={true}
            >
              <ViewEnquiryList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/enquiry/table"
          element={
            <ProtectedRoute
              requiredRoles={["admin", "manager", "staff"]}
              showHeader={true}
            >
              <ViewEnquiryTable />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin/home"
          element={
            <ProtectedRoute
              requiredRoles={["admin", "manager"]}
              showHeader={true}
            >
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/new"
          element={
            <ProtectedRoute requiredRoles={["admin"]} showHeader={true}>
              <AddNewUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute requiredRoles={["admin"]} showHeader={true}>
              <ManagerUser />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
